// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"Slideshow__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Slideshow/Slideshow.scss
 ** module id = 942
 ** module chunks = 1
 **/